import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Card, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useFetch from "../../../../hooks/useFetch";
import ImagemPadrao from '../../../../assets/no_image.jpg'
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import FormatBulletedListIcon from '@mui/icons-material/FormatListBulleted';
import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import PaginatedItems from '../../../../components/administracao/Pagination';
import { faFilter, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faSearch, faRedo } from "@fortawesome/free-solid-svg-icons";
import { CalendarIcon } from "lucide-react"; 


function BuscarItem() {
    const { params } = useParams(); // pega o que vem depois da barra na url
    const { get, post } = useFetch();

    // Roda quando a página é carregada https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    const [state, setState] = useState(() => {
        return {
            count: 0,
            page: 1,
            itens: [],
            ordem: "Alfabetica", // padrão: acervo ordenado por nome (A-Z)
            //FotoDescritivas: [],
            foto_descritiva: "",
            filtroAtivo: false,
            // transformar filtros em um objeto
            nome_item: "",
            apresentacao: "",
            material: "",
            altura: "",
            largura: "",
            comprimento: "",
            diametro: "",
            profundidade: "",
            peso: "",
            // sala: "",
            // estante: "",
            // prateleira: "",
            circunferencia: "",
            forma_aquis: "",
            dt_entrada: "",
            marcas: "",
            procedencia: "",
            origem: "",
            fabricante: "",
            conservacao: "",
            restauracao: "",
            n_patrimonial: "",
            pesquisa: "",
            solicitacao: "",
            bibliografia: "",
            historico: "",
            observacao: "",
            mostrarModal: false,
            selecionado: { nome_item: "" },
            opcoesProcedencia: [],
            opcoesCategoria: [],
            categoriasSelecionadas: [],
            procedenciasSelecionadas: [],
            // opcoesSala: [],
            // opcoesEstante: [],
            // opcoesPrateleira: [],
            // salaSelecionada: "",
            // estanteSelecionada: "",
            // prateleiraSelecionada: "",
            // data_inicial: "",
            // data_final: "",
            decada_inicial: "",
            decada_final: "",
            loading: true,
        };
    });

    const [displayFormat, setDisplayFormat] = useState("card");

    // Em telas pequenas o painel de filtros começa recolhido: assim o visitante
    // vê os resultados primeiro e abre os filtros quando quiser (em telas
    // grandes continua aberto, como antes).
    const [sidebarExpanded, setSidebarExpanded] = useState(
        () => typeof window === "undefined" || window.innerWidth >= 992
    );

    const selectRef = useRef();

    const toggleSidebar = () => {
        setSidebarExpanded(!sidebarExpanded);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                let categoriasRecebidas = await buscarCategorias({});
                // let localizacoesRecebidas = await buscarLocalizacoes({});
                let procedenciasRecebidas = await buscarProcedencias();

                // let opcoesSala = localizacoesRecebidas.salas.map(element => ({
                //     label: element
                // }));

                // let opcoesEstante = localizacoesRecebidas.estantes.map(element => ({
                //     label: element
                // }));

                // let opcoesPrateleira = localizacoesRecebidas.prateleiras.map(element => ({
                //     label: element
                // }));

                let opcoesCategoria = categoriasRecebidas.map(element => ({
                    value: element.id_categoria,
                    label: element.nome_cat
                }));

                let opcoesProcedencia = procedenciasRecebidas.map(element => ({
                    value: element,
                    label: element
                }));

                let [itensRecebidos, count] = await buscarItens({});

                setState(prevState => ({
                    ...prevState,
                    opcoesCategoria: opcoesCategoria,
                    opcoesProcedencia: opcoesProcedencia,
                    itens: itensRecebidos,
                    // opcoesEstante: opcoesEstante,
                    // opcoesSala: opcoesSala,
                    // opcoesPrateleira: opcoesPrateleira,
                    count: count,
                    loading: false,
                }));
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            }
        };

        fetchData();
    }, [params]);

    // função de paginação
    async function handlePageChange(pageNumber) {
    window.scrollTo(0, 0);
    // 1. Limpa os itens e ativa o loading ANTES da busca
    setState(prevState => ({ ...prevState, loading: true, itens: [] }));
    
    let filtroPaginacao = { page: pageNumber };
    if (state.filtroAtivo) {
        filtroPaginacao = { ...filtroPaginacao, page: pageNumber };
    }
    
    let [itens, count] = await buscarItens(filtroPaginacao);
    setState(prevState => ({ 
        ...prevState, 
        page: pageNumber, 
        itens: itens, 
        count: count, 
        loading: false 
    }));
}

    // Busca os dados do banco
    async function buscarItens(filtros) {
        if (!state.loading) setState({ ...state, loading: true });
        // filtros = { nome: "nome", descricao: "descricao" }
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        // no fim fica: nome=nome&descricao=descricao&
        try {
            let categoriasRecebidas = [];
            state.categoriasSelecionadas.forEach(element => {
                categoriasRecebidas.push(element.value);
            });
            let procedenciasRecebidas = [];
            state.procedenciasSelecionadas.forEach(element => {
                procedenciasRecebidas.push(element.value);
            });
            let body = {
                categoriasRecebidas: categoriasRecebidas,
                procedenciasRecebidas: procedenciasRecebidas,
                // salaSelecionada: state.salaSelecionada.label,
                // estanteSelecionada: state.estanteSelecionada.label,
                // prateleiraSelecionada: state.prateleiraSelecionada.label,
                decada_inicial: state.decada_inicial,
                decada_final: state.decada_final,
                ordem: state.ordem
            };
            let response = await post("/item_visitante" + query, body);
            if (response.ok) {
                let dados = response.result;
                return [dados.data, dados.count];
            }
        } catch (error) {
            console.error("Erro no buscarItens():", error);
        }
    }

    async function buscarCategorias(filtros) {
        // filtros = { nome: "nome_cat", descricao: "descricao" }
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        // no fim fica: nome_cat=nome_cat&descricao=descricao&
        try {
            let response = await get("/categoria" + query);
            if (response.status === 200) {
                let dados = response.result.data;
                return dados;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Erro no buscarCategorias():', error);
        }
    }

    async function buscarProcedencias() {
        try {
            let response = await get("/procedencia");
            if (response.ok) {
                let dados = response.result.data;
                return dados;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Erro no buscarProcedencias():', error);
        }
    }

    // async function buscarLocalizacoes(filtros) {
    //     // filtros = { nome: "nome_cat", descricao: "descricao" }
    //     let query = "?";
    //     if (filtros && Object.keys(filtros).length > 0) {
    //         for (const key in filtros) {
    //             if (filtros[key] !== "") {
    //                 query = query.concat(key, "=", filtros[key], "&");
    //             }
    //         }
    //     }
    //     // no fim fica: nome_cat=nome_cat&descricao=descricao&
    //     try {
    //         let response = await get("/distinct_localizacao" + query);
    //         if (response.status === 200) {
    //             let dados = response.result.data;
    //             return dados;
    //         } else {
    //             return [];
    //         }
    //     } catch (error) {
    //         console.error('Erro no buscarLocalizacoes():', error);
    //     }
    // }

    // Função acionada quando o usuário clica em buscar
    async function filtrarItens() {
    window.scrollTo(0, 0); // Sobe para o topo ao filtrar ou buscar
    // 1. Limpa os itens e ativa o loading IMEDIATAMENTE
    setState(prevState => ({ ...prevState, loading: true, itens: [] }));

    let filtros = {
        nome_item: state.nome_item,
        categoriasSelecionadas: state.categoriasSelecionadas,
        procedenciasSelecionadas: state.procedenciasSelecionadas,
        decada_inicial: state.decada_inicial,
        decada_final: state.decada_final,
        ordem: state.ordem,
        page: 1 // Sempre volta para a página 1 em nova busca
    };
    
    let [itens, count] = await buscarItens(filtros);
    
    setState(prevState => ({
        ...prevState,
        itens: itens,
        count: count,
        loading: false,
        filtroAtivo: true,
        page: 1
    }));
}

    function handleChange(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        if (target.type === "select-one") {
            value = target.options[target.selectedIndex].value;
        }

        setState({
            ...state,
            [name]: value,
        });
    }

    function handleSelectChange(selectedOption, name) {
        setState({
            ...state,
            [name]: selectedOption ? selectedOption.value : null
        });
    }

    function handleOrderChange(event) {
        state.ordem = event.target.value;
        filtrarItens(state.filtros);
    }

    async function limparFiltros() {
        // Recarrega a página para limpar todos os filtros
        window.location.reload();
        /*
        state.categoriasSelecionadas = [];
        state.procedenciasSelecionadas = [];
        // state.salaSelecionada = "";
        // state.estanteSelecionada = "";
        // state.prateleiraSelecionada = "";
        state.ordem = "";
        state.decada_inicial = "";
        state.decada_final = "";
        // Bstate.data_incial = "";sca os dados do banco sem filtros
        let itens = await buscarItens({});
        // Atualiza o estado com os dados buscados e reseta os valores dos campos de filtro
        setState({
            ...state,
            itens: itens,
            nome_item: "",
            // salaSelecionada: "",
            // estanteSelecionada: "",
            // prateleiraSelecionada: "",
            loading: false,
            ordem: "",
            decada_inicial: "",
            decada_final: "",
        });
        selectRef.current.value = "";*/
    }

    function changeCategoria(data) {
        state.categoriasSelecionadas = data;
        setState({ ...state, categoriasSelecionadas: data });
    }

    function changeProcedencia(data) {
        state.procedenciasSelecionadas = data;
        setState({ ...state, procedenciasSelecionadas: data });
    }

    // function changeSala(data) {
    //     state.salaSelecionada = data;
    //     setState({ ...state, salaSelecionada: data });
    // }

    // function changeEstante(data) {
    //     state.estanteSelecionada = data;
    //     setState({ ...state, estanteSelecionada: data });
    // }

    // function changePrateleira(data) {
    //     state.prateleiraSelecionada = data;
    //     setState({ ...state, prateleiraSelecionada: data });
    // }

    const customStylesSelectUni = {
        // menuPortal: menu renderizado no <body> (menuPortalTarget nos Selects),
        // para não ser cortado pelo card de filtros nem ficar sob a navbar.
        menuPortal: (base) => ({ ...base, zIndex: 1080 }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? "#987272" : state.isFocused ? "#987272" : "#495057",
            backgroundColor: state.isSelected ? "rgba(152, 114, 114, 0.1)" : state.isFocused ? "rgba(152, 114, 114, 0.05)" : "white",
            fontSize: '14px',
        }),
        control: (provided) => ({
            ...provided,
            borderColor: "#dee2e6",
            borderRadius: "6px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            minHeight: '38px',
            '&:hover': {
                borderColor: "#987272",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#987272"
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#987272",
        }),
        indicatorSeparator: () => ({
            display: 'none', // Esconde a linha que separa o indicador (seta) do resto do componente
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: state.isFocused ? "#987272" : "#987272", // Cor da seta
            '&:hover': {
                color: "#987272", // Cor da seta ao passar o mouse
                cursor: "pointer"
            },
            '&:active': {
                color: "#987272", // Cor da seta ao clicar
            },
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: "0px",
            maxWidth: "270px",
            color: "#987272"
        }),
        clearIndicator: (provided) => ({
            ...provided,
            color: "#987272",
            '&:hover': {
                color: "#987272", // Cor do indicador ao passar o mouse
                cursor: "pointer"
            },
            '&:active': {
                color: "#987272", // Cor do indicador ao clicar
            },
        })
    };

    const customStylesMulti = {
        // menuPortal: menu renderizado no <body> (menuPortalTarget nos Selects),
        // para não ser cortado pelo card de filtros nem ficar sob a navbar.
        menuPortal: (base) => ({ ...base, zIndex: 1080 }),
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            color: state.isSelected ? "#987272" : state.isFocused ? "#987272" : "#495057",
            backgroundColor: state.isSelected ? "rgba(152, 114, 114, 0.1)" : state.isFocused ? "rgba(152, 114, 114, 0.05)" : "white",
            borderColor: "#987272",
            fontSize: '14px',
        }),

        control: (defaultStyles) => ({
            ...defaultStyles,
            borderColor: "#dee2e6",
            borderRadius: "6px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            minHeight: '38px',
            '&:hover': {
                borderColor: "#987272",
            },
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: "#6c757d",
            fontSize: '14px',
        }),

        indicatorSeparator: () => ({
            display: 'none', // Esconde a linha que separa o indicador (seta) do resto do componente
        }),

        dropdownIndicator: (styles, { isFocused }) => ({
            ...styles,
            color: isFocused ? "#987272" : "#987272", // Cor da seta
            '&:hover': {
                color: "#987272", // Mantém a mesma cor quando o mouse está sobre ele
                cursor: "pointer"
            },
            '&:active': {
                color: "#987272", // Mantém a mesma cor quando é clicado
            },
        }),

        menu: (provided) => ({
            ...provided,
            borderRadius: "0px", // Ajuste o valor conforme necessário para controlar a borda do dropdown
            maxWidth: "270px",
            color: "#987272"
        }),

        singleValue: (defaultStyles) => ({
            ...defaultStyles,
            color: "#fff", // Cor da caixa selecionada
        }),

        multiValueLabel: (defaultStyles) => ({
            ...defaultStyles,
            color: "#987272",
            backgroundColor: "white",
            borderColor: "white"
        }),

        multiValueRemove: (defaultStyles) => ({
            ...defaultStyles,
            color: "#987272",
            backgroundColor: "white",
            borderColor: "white",
            '&:hover': {
                color: "#987272", // Mantém a mesma cor quando o mouse está sobre ele
                backgroundColor: "#d6b5b5cf"
            },
            '&:active': {
                color: "#987272", // Mantém a mesma cor quando é clicado
                backgroundColor: "#d6b5b5cf"
            },
        }),

        clearIndicator: (defaultStyles) => ({
            ...defaultStyles,
            color: "#987272",
            '&:hover': {
                color: "#987272", // Mantém a mesma cor quando o mouse está sobre ele
                cursor: "pointer"
            },
            '&:active': {
                color: "#987272", // Mantém a mesma cor quando é clicado
            },
        })
    };



    return (
        <>
            <div className="containerfluid">
                <div className="content" style={{ marginTop: "40px" }}>
                    <div className="row mx-0">
                        {/* Seção Hero de Busca */}
                        <section className="search-hero">
                            <div className="container">
                                <div className="search-modern-container text-center">
                                    {/* Título e Subtítulo */}
                                    <h2 className="search-hero-title">Explore o Acervo de Equipamentos</h2>
                                    <p className="search-hero-subtitle">Explore instrumentos, mobiliários e objetos que marcaram a história da FMRP-USP desde sua fundação.</p>

                                    {/* Barra de Busca e Botões */}
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-lg-10">
                                            <div className="d-flex flex-column flex-md-row gap-3 align-items-stretch">
                                                {/* Campo de Busca com Ícone */}
                                                <div className="flex-grow-1 position-relative">
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                        className="search-icon-modern"
                                                    />
                                                    <Form.Control
                                                        type="text"
                                                        className="search-input-modern w-100"
                                                        placeholder="Insira um nome ou palavra chave"
                                                        name="nome_item"
                                                        value={state.nome_item}
                                                        onChange={handleChange}
                                                        onKeyPress={(e) => e.key === 'Enter' && filtrarItens()}
                                                        style={{ height: '48px' }}
                                                    />
                                                </div>

                                                {/* Botões */}
                                                <div className="d-flex gap-2 search-modern-buttons">
                                                    <Button
                                                        className="btn-search-modern"
                                                        onClick={filtrarItens}
                                                    >
                                                        <FontAwesomeIcon icon={faFilter} className="me-2" />
                                                        Aplicar filtros e Buscar
                                                    </Button>
                                                    <Button
                                                        className="btn-reset-modern"
                                                        onClick={limparFiltros}
                                                    >
                                                        <FontAwesomeIcon icon={faRedo} className="me-2" />
                                                        <span className="d-none d-sm-inline">Redefinir</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="row">
                            {
                                sidebarExpanded ? (
                                    <div className="col-md-3 sidebar-expanded" style={{ marginRight: "0px" }}>
                                        <div className="row">
                                            <div className="col-md-12" style={{ paddingLeft: "0px" }}>
                                                <div className="sidebar-modern p-3 min-h-100">
                                                    {/* Header do Sidebar */}
                                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon={faFilter} className="text-muted" />
                                                            <h5 className="mb-0" style={{ color: '#987272', fontWeight: '600' }}>Filtros Adicionais</h5>
                                                        </div>
                                                        <button
                                                            className="filter-button-modern"
                                                            onClick={toggleSidebar}
                                                        >
                                                            <FontAwesomeIcon icon={faChevronLeft} />
                                                        </button>
                                                    </div>

                                                    {/* Card Categorias */}
                                                    <Card className="filter-card mb-3">
                                                        <Card.Header className="filter-card-header">
                                                            <Card.Title className="filter-card-title">Categorias</Card.Title>
                                                        </Card.Header>
                                                        <Card.Body className="filter-card-content">
                                                            <Form.Group>
                                                                <Select menuPortalTarget={document.body}
                                                                    name="categoriasSelecionadas"
                                                                    isMulti
                                                                    options={state.opcoesCategoria}
                                                                    value={state.categoriasSelecionadas}
                                                                    onChange={changeCategoria}
                                                                    styles={customStylesMulti}
                                                                    isDisabled={state.acao === "Visualizar"}
                                                                    placeholder="Selecionar categorias..."
                                                                />
                                                            </Form.Group>
                                                        </Card.Body>
                                                    </Card>

                                                    {/* Card Procedência */}
                                                    <Card className="filter-card mb-3">
                                                        <Card.Header className="filter-card-header">
                                                            <Card.Title className="filter-card-title">Procedência</Card.Title>
                                                        </Card.Header>
                                                        <Card.Body className="filter-card-content">
                                                            <Form.Group>
                                                                <Select menuPortalTarget={document.body}
                                                                    name="procedenciasSelecionadas"
                                                                    isMulti
                                                                    options={state.opcoesProcedencia}
                                                                    value={state.procedenciasSelecionadas}
                                                                    onChange={changeProcedencia}
                                                                    styles={customStylesMulti}
                                                                    isDisabled={state.acao === "Visualizar"}
                                                                    placeholder="Selecionar procedências..."
                                                                />
                                                            </Form.Group>
                                                        </Card.Body>
                                                    </Card>

                                                    {/* Card Período */}
                                                    <Card className="filter-card mb-3">
                                                        <Card.Header className="filter-card-header">
                                                            <Card.Title className="filter-card-title">Período</Card.Title>
                                                        </Card.Header>
                                                        <Card.Body className="filter-card-content">
                                                            <Form.Group className="mb-3">
                                                                <Form.Label style={{ fontSize: '14px', color: '#6c757d', fontWeight: '500' }}>
                                                                    Década Inicial
                                                                </Form.Label>
                                                                <Select menuPortalTarget={document.body}
                                                                    name="decada_inicial"
                                                                    options={[
                                                                        { value: "", label: "Selecionar década inicial..." },
                                                                        { value: "1950", label: "1950-1959" },
                                                                        { value: "1960", label: "1960-1969" },
                                                                        { value: "1970", label: "1970-1979" },
                                                                        { value: "1980", label: "1980-1989" },
                                                                        { value: "1990", label: "1990-1999" },
                                                                        { value: "2000", label: "2000-2009" },
                                                                        { value: "2010", label: "2010-2019" },
                                                                        { value: "2020", label: "2020-2029" },
                                                                    ]}
                                                                    value={state.decada_inicial ? {
                                                                        value: state.decada_inicial,
                                                                        label: `${state.decada_inicial}-${parseInt(state.decada_inicial) + 9}`
                                                                    } : { value: "", label: "Selecionar década inicial..." }}
                                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "decada_inicial")}
                                                                    styles={customStylesSelectUni}
                                                                    isDisabled={state.acao === "Visualizar"}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="mb-0">
                                                                <Form.Label style={{ fontSize: '14px', color: '#6c757d', fontWeight: '500' }}>
                                                                    Década Final
                                                                </Form.Label>
                                                                <Select menuPortalTarget={document.body}
                                                                    name="decada_final"
                                                                    options={[
                                                                        { value: "", label: "Selecionar década final..." },
                                                                        { value: "1950", label: "1950-1959" },
                                                                        { value: "1960", label: "1960-1969" },
                                                                        { value: "1970", label: "1970-1979" },
                                                                        { value: "1980", label: "1980-1989" },
                                                                        { value: "1990", label: "1990-1999" },
                                                                        { value: "2000", label: "2000-2009" },
                                                                        { value: "2010", label: "2010-2019" },
                                                                        { value: "2020", label: "2020-2029" },
                                                                    ]}
                                                                    value={state.decada_final ? {
                                                                        value: state.decada_final,
                                                                        label: `${state.decada_final}-${parseInt(state.decada_final) + 9}`
                                                                    } : { value: "", label: "Selecionar década final..." }}
                                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "decada_final")}
                                                                    styles={customStylesSelectUni}
                                                                    isDisabled={state.acao === "Visualizar"}
                                                                />
                                                            </Form.Group>
                                                        </Card.Body>
                                                    </Card>

                                                    {/* Separador */}
                                                    <hr style={{ borderColor: 'rgba(152, 114, 114, 0.2)', margin: '20px 0' }} />

                                                    {/* Botões de Ação */}
                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            className="btn-filter-primary"
                                                            onClick={filtrarItens}
                                                        >
                                                            Aplicar Filtros
                                                        </Button>
                                                        <Button
                                                            className="btn-filter-outline"
                                                            onClick={limparFiltros}
                                                        >
                                                            Limpar Filtros
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-md-1 sidebar-collapsed" style={{ marginRight: "0px" }}>
                                        <div className="row">
                                            <div className="col-12 text-center">
                                                <button
                                                    className="filter-button-modern mt-3"
                                                    onClick={toggleSidebar}
                                                >
                                                    <FontAwesomeIcon icon={faChevronRight} />
                                                </button>
                                                <div className="mt-2">
                                                    <small style={{ color: '#987272', writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>
                                                        Filtros
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {/* Conteúdo Principal - Ajuste a classe col-md baseado no estado do sidebar */}
                            <div className={sidebarExpanded ? "col-md-9" : "col-md-11"}>
                                <div className="row d-flex flex-row justify-content-between" style={{ marginBottom: "50px" }}>
                                    <div className="col-md-3 d-flex flex-row align-items-center mb-3 mx-2">
                                        <p className="mb-0 mr-2 text-filter">Ordenar por: </p>
                                        <Form className="flex-grow-1">
                                            <Form.Select className="form-control" name="ordem" id="filt" defaultValue={state.ordem} onChange={handleOrderChange} ref={selectRef} style={{ minWidth: "200px" }}>
                                                <option value="id_item">Padrão</option>
                                                <option value="Alfabetica">Ordem alfabética (A-Z)</option>
                                            </Form.Select>
                                        </Form>
                                    </div>
                                    <div className="col d-flex justify-content-end">
                                        {/* Seletor de visualização (cards/table) - mantém igual */}
                                        {
                                            displayFormat === "card" ?
                                                <>
                                                    <Button className="btn border border-2 btn-view" onClick={() => setDisplayFormat("card")}>
                                                        <SpaceDashboardIcon />
                                                    </Button>
                                                    <button className="btn border border-2 btn-display-format"
                                                        onClick={() => setDisplayFormat("table")}
                                                    >
                                                        <FormatBulletedListIcon className="icon-display-format" />
                                                    </button>
                                                </>
                                                :
                                                <>
                                                    <button className="btn border border-2 btn-display-format"
                                                        onClick={() => setDisplayFormat("card")}
                                                    >
                                                        <SpaceDashboardIcon className="icon-display-format" />
                                                    </button>
                                                    <Button className="btn border border-2 btn-view" onClick={() => setDisplayFormat("table")}>
                                                        < FormatBulletedListIcon />
                                                    </Button>
                                                </>
                                        }
                                    </div>
                                </div>
                                {displayFormat === "card" ? (
                                    <div className="row">
                                        <div className="container-fluid text-center">
                                            <div className="row row-cols-lg-4 row-cols-md-3 row-cols-1 g-2 g-lg-3 g-sm-4 mx-0">
                                                {state.loading ? (
                                                    // 1. PRIORIDADE TOTAL: Se está carregando, mostra os Skeletons
                                                    Array(8).fill(0).map((_, index) => (
                                                        <div key={index} className="col m-0">
                                                            <Card className="custom-card mb-4 border-0">
                                                                <Skeleton height={280} borderRadius={10} />
                                                                <Card.Body className="px-0">
                                                                    <Skeleton width="80%" height={20} className="mb-2" />
                                                                    <Skeleton width="40%" height={15} />
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    ))
                                                ) : state.itens && state.itens.length > 0 ? (
                                                    // 2. Se NÃO está carregando e TEM itens, mostra os Cards
                                                    state.itens.map((item, index) => (
                                                        <div key={index} className="col m-0">
                                                            <Link to={'/acervo/item/' + item.id_item}>
                                                                <Card className="custom-card mb-4">
                                                                    <div className="img-wrapper img-fluid">
                                                                        {item.foto_descritiva ? (
                                                                            <Card.Img variant="top" src={"data:image/jpeg;base64," + item.foto_descritiva} alt="Imagem do item" />
                                                                        ) : (
                                                                            <Card.Img variant="top" src={ImagemPadrao} alt="Imagem padrão" />
                                                                        )}
                                                                    </div>
                                                                    <Card.Body>
                                                                        <Card.Title className="card-font">{item.nome_item}</Card.Title>
                                                                        <Card.Text className="card-font">
                                                                            <div className="card-text">
                                                                                <CalendarIcon className="calendar-icon" size={16} />
                                                                                {item.ano_fabricacao || item.decada_fabricacao || "Sem data"}
                                                                            </div>
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Link>
                                                        </div>
                                                    ))
                                                ) : (
                                                    // 3. Se NÃO está carregando e NÃO encontrou nada
                                                    <div className="col-12 text-center py-5">
                                                        <p className="text-muted">Nenhum item encontrado.</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    /* VISUALIZAÇÃO EM TABELA */
                                    <Table className="table table-hover" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ width: "25%" }}>Foto</th>
                                                <th scope="col" style={{ width: "25%" }}>Nome</th>
                                                <th scope="col" style={{ width: "25%" }}>Resumo</th>
                                                <th scope="col" style={{ width: "25%" }}>Data</th>
                                            </tr>
                                        </thead>
                                        <tbody className="pt-2">
                                            {state.loading ? (
                                                // Skeleton para as linhas da tabela enquanto carrega
                                                Array(5).fill(0).map((_, index) => (
                                                    <tr key={index}>
                                                        <td><Skeleton height={80} width={120} /></td>
                                                        <td><Skeleton width="90%" /></td>
                                                        <td><Skeleton width="90%" /></td>
                                                        <td><Skeleton width="50%" /></td>
                                                    </tr>
                                                ))
                                            ) : state.itens && state.itens.length > 0 ? (
                                                state.itens.map((item, index) => (
                                                    <tr key={index} style={{ cursor: 'pointer' }} onClick={() => window.location.href = `/acervo/item/${item.id_item}`}>
                                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                                            {/* Tamanho controlado 100% pela classe .img-wrapper-tabela
                                                                (buscar.scss) — sem style inline aqui, pra não brigar
                                                                com o width/height/object-fit definidos lá e deixar a
                                                                miniatura preencher todo o box. */}
                                                            <div className="img-wrapper-tabela">
                                                                <img
                                                                    src={item.foto_descritiva ? `data:image/jpeg;base64, ${item.foto_descritiva}` : ImagemPadrao}
                                                                    alt="item"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>{item.nome_item}</td>
                                                        <td>{item.apresentacao}</td>
                                                        <td>{item.ano_fabricacao || item.decada_fabricacao || "Sem data"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="4" className="text-center">Nenhum item encontrado</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                        </div>
                        <br />
                        <div className='row pt-4'>
                            <div className='col'>
                                {
                                    state.itens && state.itens.length > 0 ?
                                        <PaginatedItems
                                            itemCount={state.count}
                                            itemsPerPage={20}
                                            handlePageChange={handlePageChange}
                                        />
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BuscarItem;